// src/pages/auth/VerifyEmailPage.tsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../../services/auth.service';
import logonegro from '../../assets/images/logonegro.svg';
import fondoPantalla from '../../assets/images/fondo_pantalla.svg';
import '../../assets/styles/auth-common.css';
import Footer from '../../components/layout/footer';
import { useWindow } from '../../context/WindowContext';

const VerifyEmailPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { windowWidth, isMobile } = useWindow();
  const [email, setEmail] = useState(location.state?.email || '');
  const [showEmailInput] = useState(!location.state?.email);
  
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState<'EN' | 'ES'>('EN');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email) {
      setError('Please enter your email');
      return;
    }

    try {
      setLoading(true);
      await authService.validateEmailToken({ 
        email: email,
        code: verificationCode 
      });
      navigate('/email-verified', { replace: true });
    } catch (err: any) {
      console.error('Verification error:', err);
      setError(err.message || 'Error validating email');
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = () => {
    navigate('/resend-code', { 
      state: email ? { email } : undefined 
    });
  };
  const rootStyle = {
    '--bg-image': `url(${fondoPantalla})`
  } as React.CSSProperties;

  return (
    <div style={{ backgroundColor: '#003DA5', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px', width: '100%' }}>
        {/* Logo centrado */}
        <div style={{ textAlign: 'center', width: '400px', maxWidth: '90vw' }}>
          <img src={logonegro} alt="Kanz Bank" style={{ width: 'auto', height: '252px', maxWidth: '100%' }} />
        </div>

        {/* Formulario centrado */}
        <form className="auth-form-container" onSubmit={handleSubmit} style={{ width: '400px', maxWidth: '90vw', position: 'relative', zIndex: 10, margin: '0', gridColumn: 'unset' }}>
          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          {showEmailInput && (
            <div className="input-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                disabled={loading}
                required
              />
            </div>
          )}

          <div className="verification-info">
            <p>Please enter the verification code sent to:</p>
            <strong>{email}</strong>
          </div>

          <div className="input-group">
            <label htmlFor="verificationCode">Verification Code</label>
            <input
              type="text"
              id="verificationCode"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              placeholder="Enter verification code"
              disabled={loading}
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading || !verificationCode}
          >
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>

          <div className="sm:secondary-buttons flex">
            <button
              type="button"
              className="btn-signup"
              onClick={handleResendCode}
              disabled={loading}
            >
              Resend Code
            </button>
            <button
              type="button"
              className="btn-validate"
              onClick={() => navigate('/')}
              disabled={loading}
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>

      <Footer />
    </div>
  );
};

export default VerifyEmailPage;